import { Rule } from "../models/Rule";
import { RuleValidationResult } from "./RuleValidationResult";
import { RuleValidationService } from "./RuleValidationService";


export class RuleOrderValidationService extends RuleValidationService {

    static readonly injectableKey = 'RuleOrderValidationService';

    get injectableKey() {
        return (this.constructor as typeof RuleOrderValidationService).injectableKey;
    }

    public validateRules(rules: Array<Rule>, result?: RuleValidationResult): RuleValidationResult {
        if (!rules) throw Error("rules are required!");

        if(!result) result = new RuleValidationResult();

        const sparseDataCount = rules.filter(r => r._type === "sparse_data").length;
        if (sparseDataCount > 1) {
            result.addError("Only one sparse_data rule is allowed.");
        }

        rules.forEach((rule: Rule, index: number) => {

            switch (rule._type) {
                case "sparse_data":
                    if (index !== rules.length - 1) {
                        result.addError("A sparse_data rule must be the final rule.");
                    }
                    break;
            }

        });

        return result;
    }

}